/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View } from 'react-native';

import Highcharts from '@components/chart/Highcharts';

import { MONTH_NAME_SIMPLE } from '@/constants';
import { isNative } from '@global/screens';

function BusinessChart({
  data,
  popup = false,
  line = false,
  hideCategory = false,
  colors = [],
  columnStackingOption = '',
  tooltipYFormat = '',
}) {
  return data.length ? (
    <View>
      <Highcharts
        height={!isNative || popup ? 420 : 200}
        type={'line'}
        data={data}
        categories={MONTH_NAME_SIMPLE}
        showCategories={!hideCategory}
        style={popup ? { width: 800 } : {}}
        colors={colors}
        // columnStackingOption={columnStackingOption}
        tooltipYFormat={tooltipYFormat}
      />
    </View>
  ) : (
    false
  );
}

export default React.memo(BusinessChart, (prev, next) => prev == next);
